import { MainRequests } from '../types/requests';

export class MainStoreState {
  requests: MainRequests = {
    preview: {},
    hidePreview: {},
  };
}
